import { Button, Menu, MenuItem } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import { useRefresh, useTranslate, useUpdate } from "react-admin";

import { Link } from "react-router-dom";
import { stringify } from "query-string";
import useUserStatus from "../useUserStatus";

const AddUserBreakButton = React.forwardRef(({ record }, ref) => {
  const translate = useTranslate();
  return (
    <MenuItem
      component={Link}
      to={{
        pathname: `/user-breaks/create`,
        search: stringify({
          source: JSON.stringify({
            user_id: record.user_id,
            substitutive_declaration_id: record.substitutive_declaration_id,
          }),
        }),
      }}
    >
      {translate("ra.action.add_user_break")}
    </MenuItem>
  );
});
const ToggleConfirmButton = React.forwardRef(
  ({ record, status, onClick }, ref) => {
    const translate = useTranslate();
    const refresh = useRefresh();
    const [update, { loading }] = useUpdate(
      "substitutive-declarations-users",
      record?.id,
      {
        ...record,
        status: status === "not_confirmed" ? "confirmed" : "not_confirmed",
      },
      record,
      {
        onSuccess: () => !onClick() && refresh(),
        onFailure: () => !onClick(),
      }
    );
    return (
      <MenuItem onClick={update} disabled={loading}>
        {translate(
          `ra.action.${status === "not_confirmed" ? "confirm" : "cancel"}_user`
        )}
      </MenuItem>
    );
  }
);

const UserMenuButton = ({ disabled, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const status = useUserStatus(props?.record);
  const translate = useTranslate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Fragment>
      <Button
        aria-controls="user-menu"
        aria-haspopup="true"
        disabled={disabled}
        onClick={handleClick}
        variant="contained"
        color="primary"
      >
        {translate("ra.action.exec_action")}
      </Button>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {status !== "auto_confirmed" && (
          <ToggleConfirmButton
            {...props}
            status={status}
            onClick={handleClose}
          />
        )}
        <AddUserBreakButton {...props} />
      </Menu>
    </Fragment>
  );
};
export default UserMenuButton;
